import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Paper, CircularProgress, IconButton, InputAdornment, useMediaQuery, useTheme } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Login } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import apiClient from '../BaseUrl/apiClient';
import TokenService from '../service/TokenService';
import { useAuthentication } from '../customHook/useAuthentecation';
import { IP, Copyright, Developer } from '../constants/Constants';
import TrainIcon from '@mui/icons-material/Train';
import { API_BASE_URL } from '../constants/Constants';


//import TrainAnimation from '../Animation/Trainanimation';
const LoginPage = () => {
  const [buttonLoading, setButtonLoading] = useState(false);
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [step, setStep] = useState(1);
  const [showPassword, setShowPassword] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const { setAuth } = useAuthentication();
  const navigate = useNavigate();
  const theme = useTheme();









  // Axis Client for PHP API requests
  const loginUrl = `/login/login.php`;
  const verifyOtpUrl = `/login/verify-otp.php`;

  const handleLoginSubmit = async () => {
    setPageLoader(true);
    setButtonLoading(true);
    try {
      const response = await apiClient.post(loginUrl, { userId, password });
      alert(" HI    " + response.data.message);
      setStep(2);
    } catch (error) {
      alert(error.response?.data?.message || 'Login failed');
    }
    setPageLoader(false);
    setButtonLoading(false);
  };

  const handleOtpSubmit = async () => {
    setPageLoader(true);
    setButtonLoading(true);
    try {

    // console.log('OTP:', otp);
    // console.log('User ID:', userId);
    // console.log('Verify OTP URL:', verifyOtpUrl);
      const response = await apiClient.post(verifyOtpUrl, { userId, otp });
     // console.log("Full response:", response);
     console.log(response.data.status);
      TokenService.setTokenDetails(response.data.data);
     setAuth(response.data.data);
     navigate('/dashboard');
    } catch (error) {
      alert(error.response?.data?.message);
    }
    setPageLoader(false);
    setButtonLoading(false);
  };

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      step === 1 ? handleLoginSubmit() : handleOtpSubmit();
    }
  };

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isMediumScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));

  // Adjust the paper width and text size based on the screen size
  const paperWidth = isSmallScreen ? '90%' : isMediumScreen ? '80%' : '400px';
  const fontSize = isSmallScreen ? '75%' : isMediumScreen ? '80%' : '125%';
  const padding = isSmallScreen ? 2 : 4;

  return (
    <Box
      sx={{
        backgroundColor: 'white',
        height: '100vh', // Ensure the Box takes up the full visible height
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%', // Ensures the Box covers the full width
        position: 'relative', // Ensures the Box stays inside the viewport
        top: 0,
        left: 0,
        padding: isSmallScreen ? '5px' : '10px', // Margin-like padding for small screens
        boxSizing: 'border-box', // Ensures padding is included in the box's total size
        overflow: 'auto', // Enables scrolling if content overflows
      }}
    >
      {pageLoader && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            zIndex: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      )}

      <Paper
        elevation={8}
        sx={{
          width: paperWidth,
          padding: padding,
          borderRadius: 4,
          textAlign: 'center',
          background: 'linear-gradient(180deg,rgb(246, 246, 239) 15%,rgb(165, 228, 245) 63%,rgb(143, 176, 211) 80%)',

          backgroundSize: 'cover',


          color: 'white',
          // minHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          height: 'auto',
          maxWidth: '100%',
          margin: isSmallScreen ? '10px' : '20px',
          boxShadow: '0 8px 16px rgba(0,0,0,0.25)',
          position: 'relative',
          overflow: 'hidden',
        }}
      >

        {/* <CleaningAnimation /> */}
        <Typography sx={{ color: 'blue', display: 'inline' }}>
          <TrainIcon />
        </Typography>
        <Typography sx={{ fontSize, mb: 3, fontWeight: 'bold', letterSpacing: '1px', color: '#005A9E' }}>

          Coach Cleaning Monitoring System
        </Typography>
        {/* <TrainAnimation /> */}


        {step === 1 && (
          <>
            <TextField
              label="User ID"
              variant="outlined"
              fullWidth
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              onKeyPress={handleKeyPress}
              sx={{ mb: 2, backgroundColor: 'white', borderRadius: 1 }}
            />
            <TextField
              label="Password"
              type={showPassword ? 'text' : 'password'}
              variant="outlined"
              fullWidth
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={handleKeyPress}
              sx={{ mb: 3, backgroundColor: 'white', borderRadius: 1 }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleClickShowPassword} edge="end" aria-label="toggle password visibility">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button
              variant="contained"
              fullWidth
              onClick={handleLoginSubmit}
              startIcon={<Login />}
              sx={{
                py: 1.2,
                fontSize: '16px',
                backgroundColor: '#005A9E',
                '&:hover': { backgroundColor: '#004A8E' },
                color: 'white',
              }}
              disabled={buttonLoading}
            >
              Login
            </Button>
          </>
        )}

        {step === 2 && (
          <>
            <TextField
              label="Enter OTP"
              variant="outlined"
              fullWidth
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              onKeyPress={handleKeyPress}
              sx={{ mb: 3, backgroundColor: 'white', borderRadius: 1 }}
            />
            <Button
              variant="contained"
              fullWidth
              onClick={handleOtpSubmit}
              sx={{
                py: 1.2,
                fontSize: '16px',
                backgroundColor: '#005A9E',
                '&:hover': { backgroundColor: '#004A8E' },
                color: 'white',
              }}
              disabled={buttonLoading}
            >
              Verify OTP
            </Button>
          </>
        )}

        <Typography variant="body2" sx={{ mt: 4 }}>Your IP: {IP}</Typography>
        {Developer()}
        {Copyright()}
      </Paper>
    </Box>
  );
};

export default LoginPage;
